import {
  LineWithSolidLabel,
  TextareaLine,
  TimeSelect,
} from "data/CellComponent";
import {
  Header1,
  Instruction,
  InstructionWithContent,
} from "../../BlockComponent";
import { ThoughtRecordLastCard, ThoughtRecordTemplate } from "./thoughtRecord";
import { getEarlyQuarterTime } from "../../../utils/timeUtils";

const NotificationTimeBlock = InstructionWithContent(
  "notification_2",
  [
    [
      TimeSelect({
        id: "notification_time",
        value: getEarlyQuarterTime(),
        timeSelectStep: "quarter",
      }),
    ],
  ],
  { blockId: "알림 허용" }
);

export const Content_2_2_T = (
  isPushNotificationGranted: boolean,
  trk?: string
) => [
  Instruction("initial_typography_0_1"),
  Instruction("initial_typography_0_2"),
  Instruction("initial_typography_0_3"),
  Instruction("initial_typography_0_4"),
  Instruction("initial_typography_0_5"),
  Instruction("initial_typography_0_5_1"),
  Instruction("initial_typography_0_5_2"),
  InstructionWithContent(
    `initial_typography_0_6`,
    LineWithSolidLabel("나의 고민", TextareaLine({ id: "고민" }))
  ),
  Instruction("initial_typography_1"),
  ...ThoughtRecordTemplate({
    trk: trk,
    sentiment: "negative",
    isSituationUpgraded: false,
    isEmotionUpgraded: false,
    isPhysicalResponseUpgraded: false,
    isBehaviorUpgraded: false,
    isWillingnessAvailable: false,
    isFromMeditationRecord: false,
  }),
  Header1("initial_typography_2"),
  Instruction("initial_typography_3"),
  Instruction("initial_typography_4"),
  Instruction("initial_typography_5"),
  Instruction("initial_typography_6"),
  Instruction("initial_typography_7"),
  Instruction("initial_typography_8"),
  Instruction("initial_typography_9"),
  Instruction("initial_typography_10"),
  Instruction("initial_typography_11"),
  Instruction("initial_typography_12"),
  Instruction("initial_typography_12_1"),
  Instruction("initial_typography_13"),
  ...(!isPushNotificationGranted
    ? [
        InstructionWithContent("notification_1", [
          [
            {
              type: "pushNotification",
              content: { showFromIdIfDenied: "알림 미허용" },
            },
          ],
        ]),
        NotificationTimeBlock,
      ]
    : [NotificationTimeBlock]),
  Instruction(`initial_typography_14`, {
    blockId: "알림 미허용",
  }),
  ...ThoughtRecordLastCard,
];
